module.exports = __webpack_public_path__ + "img/banner_bg_3.c210313a.jpg";